module.exports = __webpack_public_path__ + "static/media/feature-live-brackets.e2f0557d.png";